/**
 * Video testimonials carousel.
 * - Desktop (>1100px): prev/next arrows page 4 cards at a time (transform).
 * - Mobile/tablet (<=1100px): native swipe/scroll track, all cards visible.
 *
 * The 1101px breakpoint matches the CSS switch in
 * sections/video-testimonials-grid.liquid.
 */
(() => {
  if (window.__vtCarouselInit) return;
  window.__vtCarouselInit = true;

  const PER_PAGE = 4;
  const desktop = window.matchMedia('(min-width: 1101px)');

  const init = (root) => {
    const track = root.querySelector('[data-vt-track]');
    const prev = root.querySelector('[data-vt-prev]');
    const next = root.querySelector('[data-vt-next]');
    if (!track || !prev || !next) return;

    let page = 0;

    const items = () => Array.from(track.children);
    const pages = () => Math.max(1, Math.ceil(items().length / PER_PAGE));

    function render() {
      if (desktop.matches) {
        if (page >= pages()) page = 0;
        const first = items()[page * PER_PAGE];
        track.style.transform = first ? `translateX(${-first.offsetLeft}px)` : '';
        prev.hidden = page === 0;
        next.hidden = pages() <= 1;
      } else {
        track.style.transform = '';
        prev.hidden = true;
        next.hidden = true;
      }
    }

    next.addEventListener('click', () => {
      if (!desktop.matches) return;
      page = (page + 1) % pages();
      render();
    });
    prev.addEventListener('click', () => {
      page = Math.max(0, page - 1);
      render();
    });

    window.addEventListener('resize', render, { passive: true });
    if (desktop.addEventListener) desktop.addEventListener('change', render);
    render();
  };

  document.querySelectorAll('[data-vt-carousel]').forEach(init);
})();
